import { useSelector } from 'store';

const useActiveAccountRole = () => {
  const accountInContext = useSelector((state) => state.accountInContext);

  return accountInContext.accountRole?.teamRole;
};

export default useActiveAccountRole;
